import { render, staticRenderFns } from "./ModalDeleteTransfer.vue?vue&type=template&id=5bd9412e&"
import script from "./ModalDeleteTransfer.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports